
export function stringMaxLength(input, maxLength) {
    if (input.length > maxLength) {
        return input.substring(0, maxLength) + '...'
    }

    return input
}

export function simpleSafeStringToHTML(content) {
    return content.replace(/\n/gi, '<br />')
}

export const currencyUSDFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

export const currencyUSDFormat = currencyUSDFormatter.format
